import { connect } from 'react-redux'
import { compose } from 'recompose'

import { addLoan } from 'src/actions/loan'
import { selectByStatus } from 'src/store/selectors/home/loans'

const LoansContainer = compose(
  connect(
    state => selectByStatus(state),
    dispatch => ({
      addLoan: () => dispatch(addLoan())
    })
  )
)

export default LoansContainer
